export default __webpack_public_path__ + "assets/completion-mark.6ce5f3e4.svg";